import httpClient from '@/api/httpClient';

const getTrustpilotInfo = () => httpClient.get('api/trustpilot/general-info');

const getTrustpilotReviews = language => httpClient.get(`api/trustpilot/${language}/reviews`);

export { getTrustpilotInfo, getTrustpilotReviews };
